// M146 Fase 3 — Universele PageShell.
// Levert consistente eyebrow + H1 + subtitle + optionele actions-rechts
// en een content-slot. Alle Instellingen-, Content-, Kanalen-, Resultaten-
// en Markt-pagina's gebruiken dit component zodat spacing, kleur en typografie
// exact matchen tussen pagina's.
//
// Fase 3 fix (2026-09-17 nacht) — Typografie centraal afgedwongen:
// - Eyebrow: 12px, weight 600, letter-spacing 0.06em, text-transform uppercase,
//   font-variant normal (voorkomt browser-smallcaps-drift bij Inter).
// - H1: 32px mobiel, 44px desktop (>=768px), font-weight 700, tight tracking.
// Deze specs zitten in inline-style zodat een pagina er NIET onderuit kan.

const EYEBROW_STYLE = {
  fontSize: "12px",
  fontWeight: 600,
  letterSpacing: "0.06em",
  textTransform: "uppercase",
  fontVariant: "normal",
  lineHeight: 1.4,
};

export function PageShell({ eyebrow, title, subtitle, actions, children }) {
  return (
    <div className="pt-2" data-testid="page-shell">
      <div className="flex items-start justify-between gap-4 flex-wrap mb-6">
        <div className="min-w-0">
          {eyebrow && (
            <div
              className="text-accent-teal"
              style={EYEBROW_STYLE}
              data-testid="page-shell-eyebrow"
            >
              {eyebrow}
            </div>
          )}
          <h1
            className="mt-2 font-bold text-text-primary tracking-tight text-[32px] md:text-[44px]"
            style={{ lineHeight: 1.1, letterSpacing: "-0.02em" }}
            data-testid="page-shell-title"
          >
            {title}
          </h1>
          {subtitle && (
            <p className="mt-2 text-base text-text-muted max-w-2xl" data-testid="page-shell-subtitle">
              {subtitle}
            </p>
          )}
        </div>
        {actions && <div className="shrink-0 flex items-center gap-2">{actions}</div>}
      </div>
      {children}
    </div>
  );
}

export default PageShell;
